import React from "react";
import ReactDOM from "react-dom/client";
// Polices auto-hébergées (souveraineté : aucun appel à Google Fonts)
import "@fontsource/inter/200.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/dm-serif-display/400.css";
import "@fontsource/dm-serif-display/400-italic.css";
import "@fontsource/plus-jakarta-sans/300.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource-variable/fraunces/index.css";
import "@fontsource-variable/fraunces/wght-italic.css";
// La police des rapports P&W, auto-hébergée : la charte de la référence est en
// Poppins gras, que l'import Google (poids 400 seul) ne fournit pas.
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "./index.css";
import {RouterProvider} from "react-router-dom";
import router from "./router";
import {ContextProvider} from "./contexts/ContextProvider";
import {QueryClientProvider} from "react-query";
import { queryClient } from './api/queryClient';
import {I18nextProvider} from "react-i18next";
import i18n from './i18n';

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
                <ContextProvider>
                    <RouterProvider router={router}/>
                </ContextProvider>
            </QueryClientProvider>
        </I18nextProvider>
    </React.StrictMode>
);
